export const LOCAL_STORE_NAME_CONFIG = {
  REMEMBER_EMAIL: "em:remember_email",
  /** Account → Security idle-logout preference (drives the AuthGuard idle timer). */
  SESSION_TIMEOUT: "em:session_timeout",
};
